// src/utils/store/emitter.ts
const createEmitter = () => {
	const listeners = /* @__PURE__ */ new Set();
	const queue = [];
	let draining = false;
	const drain = (event) => {
		[...listeners].forEach((listener) => {
			if (!listeners.has(listener)) return;
			try {
				listener(event);
			} catch (error) {
				console.error("A subscriber threw while handling an event", error);
			}
		});
	};
	const emit = (event) => {
		queue.push(event);
		if (draining) return;
		draining = true;
		try {
			for (const queued of queue) drain(queued);
		} finally {
			queue.length = 0;
			draining = false;
		}
	};
	const subscribe = (listener) => {
		listeners.add(listener);
		return () => {
			listeners.delete(listener);
		};
	};
	const clear = () => {
		listeners.clear();
		queue.length = 0;
	};
	return {
		emit,
		subscribe,
		clear
	};
};
// src/utils/store/store.ts
const createStore = (initial) => {
	const changes = createEmitter();
	let value = initial;
	const get = () => value;
	const subscribe = changes.subscribe;
	const dispose = () => {
		value = initial;
		changes.clear();
	};
	const readable = {
		get,
		subscribe,
		dispose
	};
	const set = (next) => {
		if (Object.is(next, value)) return;
		value = next;
		changes.emit(value);
	};
	const asReadable = () => readable;
	return {
		...readable,
		set,
		asReadable
	};
};
export { createEmitter as n, createStore as t };

//# sourceMappingURL=store-HP0zRcLz.js.map